import React from 'react'
import { motion } from 'framer-motion'

const CoverPage = ({ onStart }) => {
  return (
    <div className="cover-container">
      <motion.div 
        className="cover-content"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <div className="cover-image-container">
          <div className="spiritual-mandala">
            <div className="mandala-ring ring-1"></div>
            <div className="mandala-ring ring-2"></div>
            <div className="mandala-ring ring-3"></div>
            <div className="mandala-core"></div>
          </div>
        </div>

        <motion.h1 
          className="book-title"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          Caminos de Luz Interior
        </motion.h1>

        <motion.p 
          className="book-subtitle"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.8 }}
        >
          Un viaje interactivo hacia tu despertar espiritual
        </motion.p>

        <motion.div 
          className="book-author"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.8 }}
        >
          <span className="author-label">Escrito por</span>
          <span className="author-name">Tu Nombre</span>
        </motion.div>

        <motion.button 
          className="start-button"
          onClick={onStart}
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.8 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="button-text">Comenzar el Viaje</span>
          <span className="button-icon">→</span>
        </motion.button>

        <motion.div 
          className="cover-features"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.8 }}
        >
          <div className="feature">
            <span className="feature-icon">🎧</span>
            <span className="feature-text">Audio guiado</span>
          </div>
          <div className="feature">
            <span className="feature-icon">✨</span>
            <span className="feature-text">Animaciones</span>
          </div>
          <div className="feature">
            <span className="feature-icon">📝</span>
            <span className="feature-text">Notas personales</span>
          </div>
        </motion.div>
      </motion.div>

      <div className="cover-background">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="floating-particle"
            initial={{ 
              x: Math.random() * 100, 
              y: Math.random() * 100,
              opacity: 0 
            }}
            animate={{ 
              y: [0, -30, 0],
              opacity: [0.3, 0.7, 0.3]
            }}
            transition={{
              duration: 3 + Math.random() * 4,
              repeat: Infinity,
              delay: Math.random() * 2
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default CoverPage
